import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { DeliveryAddress } from '../models/address';
import { deliveryTerminalSelector } from './state.selectors';
import { DeliveryType } from 'app/models/user-order.model';

export interface CartTotal {
  quantity: number;
  price: number;
}

export const organizationInfoSelector = createSelector(
  (state: AppState) => {
    return state.organizationInfo.organizationInfo;
  },
  organizationInfo => organizationInfo
);

export const pickupAddressesSelector = createSelector(
  organizationInfoSelector,
  organizationInfo => {
    if (organizationInfo) {
      const takeawayTerminals = organizationInfo.deliveryTerminals.filter(deliveryTerminal => deliveryTerminal.isSupportTakeaway);
      return takeawayTerminals.map<DeliveryAddress>(takeawayTerminal => {
        return {
          id: takeawayTerminal.id,
          addressId: null,
          type: DeliveryType.PICKUP,
          name: takeawayTerminal.name,
          deliveryPoint: takeawayTerminal.deliveryPoint,
          deliveryTerminal: takeawayTerminal
        };
      });
    } else {
      return [];
    }
  }
);

export const pickupDeliveryAddressesSelector = createSelector(
  organizationInfoSelector,
  organizationInfo => {
    if (organizationInfo) {
      const takeawayTerminals = organizationInfo.deliveryTerminals.filter(deliveryTerminal => deliveryTerminal.isSupportTakeaway);
      return takeawayTerminals.map<DeliveryAddress>(takeawayTerminal => {
        return {
          id: takeawayTerminal.id,
          addressId: null,
          type: DeliveryType.PICKUP,
          name: takeawayTerminal.name,
          deliveryPoint: takeawayTerminal.deliveryPoint,
          deliveryTerminal: takeawayTerminal
        };
      });
    } else {
      return [];
    }
  }
);

export const deliveryTerminalsSelector = createSelector(
  (state: AppState) => {
    return state.organizationInfo.organizationInfo?.deliveryTerminals ?? [];
  },
  x => x
);

export const paymentTypesSelector = createSelector(
  deliveryTerminalSelector,
  x => x?.paymentTypes ?? []
);

